import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ad6b370"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "chips" }
const _hoisted_3 = { class: "chip incident-type" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "dates" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-source" }, "경찰청(UTIC) 제공", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["road-event-row", { past: $setup.isPastRoadEvent }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString($props.roadEvent.incidentTypeName), 1 /* TEXT */),
        _createElementVNode("span", {
          class: _normalizeClass(["chip", $setup.incidentGradeLookupTable[$props.roadEvent.incidentGradeName]])
        }, _toDisplayString($props.roadEvent.incidentGradeName), 3 /* TEXT, CLASS */)
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString($props.roadEvent.title), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_5, _toDisplayString($setup.displayDates), 1 /* TEXT */),
      _hoisted_6
    ])
  ], 2 /* CLASS */))
}